import * as angular from 'angular';
import template from "./line-selection.directive.tpl.html";

interface LineSelectionScope extends angular.IScope {
  ngName: string;
  ngReadonly: boolean;
  ngDisabled: boolean;
  ngRequired: boolean;
  ngModel: any;
  form: angular.IFormController;
  linesSelected: string;
  modelChanged: () => any;
}

export default angular
  .module('aps.directives.lineSelection', [])
  .directive('lineSelection', () => {
    return {
      replace: true,
      scope: {
        ngModel: '=',
        ngReadonly: '=',
        ngDisabled: '=',
        ngRequired: '=',
        ngName: '=',
        form: '='
      },
      link: (scope: LineSelectionScope) => {
        var setLinesSelected = () => {
          if (!scope.ngModel) {
            scope.linesSelected = '';
            return;
          }

          let selected = Object.keys(scope.ngModel)
            .filter(key => scope.ngModel[key]);
          if (selected.length === 0) {
            scope.linesSelected = '';
            return;
          }

          scope.linesSelected = 'yes'
        };

        setLinesSelected();
        scope.modelChanged = setLinesSelected;
      },
      template: template,
    };
  })
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/line-selection.directive.ts